import { TOO_MANY_REQUESTS_ERROR_CODE } from './constants';

export default function (error, customerInfo, options) {
  if (error) {
    const { status, crossDomain, response } = error;

    let result = {
      customerInfo,
      data: options,
    };

    if (crossDomain || !response) {
      result.error = 'NETWORK_CONNECTION_ERROR';
    } else if (response) {
      const {
        headers: { 'x-powered-by': xPoweredBy },
      } = response;
      if (xPoweredBy && xPoweredBy.includes('OneTwoTrip')) {
        result.error = 'NETWORK_SERVER_ERROR';
      } else {
        result.error = 'NETWORK_CONNECTION_ERROR';
      }
      if (status === TOO_MANY_REQUESTS_ERROR_CODE) {
        result = response.body;
      }
    }

    return result;
  }

  return '';
}

export function checkNetworkErrorCode(error) {
  const code = (error && error.error) || error;

  return code === 'NETWORK_SERVER_ERROR' || code === 'NETWORK_CONNECTION_ERROR';
}
